// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chart-container {
  width: 90%;
  height: 90%;
  margin: auto;
  padding: 20px;
  font-family: Arial, sans-serif;
}

.chart {
  padding-bottom: 10px;
  margin-bottom: 40px;
}

.table {
  margin: 20px 0;
}

.table h2 {
  text-align: center;
  margin-bottom: 10px;
}

.table table {
  width: 100%;
  border-collapse: collapse;
  margin: 0 auto;
}

.table th,
.table td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: center;
}

.table th {
  background-color: #f2f2f2;
  font-weight: bold;
}

.table tr:nth-child(even) {
  background-color: #f9f9f9;
}

.table tr:hover {
  background-color: #ddd;
}

.table th,
.table td {
  border: 1px solid #ddd;
  padding: 8px;
}

.table th {
  padding-top: 12px;
  padding-bottom: 12px;
  background-color: #4caf50;
  color: white;
}

.export-button {
  background-color: #4caf50; /* Green background */
  border: none; /* Remove borders */
  color: white; /* White text */
  padding: 15px 32px; /* Some padding */
  text-align: center; /* Centered text */
  text-decoration: none; /* Remove underline */
  display: inline-block; /* Inline-block display */
  font-size: 16px; /* Font size */
  margin: 14px 12px; /* Margins for spacing */
  cursor: pointer; /* Pointer cursor on hover */
  border-radius: 4px; /* Rounded corners */
  transition: background-color 0.3s, transform 0.2s; /* Smooth transitions */
}

.export-button:hover {
  background-color: #45a049; /* Darker green on hover */
  transform: scale(1.05); /* Slightly enlarge on hover */
}

.export-button:active {
  background-color: #388e3c; /* Even darker green when clicked */
  transform: scale(0.95); /* Slightly shrink on click */
}
`, "",{"version":3,"sources":["webpack://./src/styles/Rack.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;EAEE,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB,EAAE,qBAAqB;EAChD,YAAY,EAAE,mBAAmB;EACjC,YAAY,EAAE,eAAe;EAC7B,kBAAkB,EAAE,iBAAiB;EACrC,kBAAkB,EAAE,kBAAkB;EACtC,qBAAqB,EAAE,qBAAqB;EAC5C,qBAAqB,EAAE,yBAAyB;EAChD,eAAe,EAAE,cAAc;EAC/B,iBAAiB,EAAE,wBAAwB;EAC3C,eAAe,EAAE,4BAA4B;EAC7C,kBAAkB,EAAE,oBAAoB;EACxC,iDAAiD,EAAE,uBAAuB;AAC5E;;AAEA;EACE,yBAAyB,EAAE,0BAA0B;EACrD,sBAAsB,EAAE,8BAA8B;AACxD;;AAEA;EACE,yBAAyB,EAAE,mCAAmC;EAC9D,sBAAsB,EAAE,6BAA6B;AACvD","sourcesContent":[".chart-container {\n  width: 90%;\n  height: 90%;\n  margin: auto;\n  padding: 20px;\n  font-family: Arial, sans-serif;\n}\n\n.chart {\n  padding-bottom: 10px;\n  margin-bottom: 40px;\n}\n\n.table {\n  margin: 20px 0;\n}\n\n.table h2 {\n  text-align: center;\n  margin-bottom: 10px;\n}\n\n.table table {\n  width: 100%;\n  border-collapse: collapse;\n  margin: 0 auto;\n}\n\n.table th,\n.table td {\n  border: 1px solid #ddd;\n  padding: 8px;\n  text-align: center;\n}\n\n.table th {\n  background-color: #f2f2f2;\n  font-weight: bold;\n}\n\n.table tr:nth-child(even) {\n  background-color: #f9f9f9;\n}\n\n.table tr:hover {\n  background-color: #ddd;\n}\n\n.table th,\n.table td {\n  border: 1px solid #ddd;\n  padding: 8px;\n}\n\n.table th {\n  padding-top: 12px;\n  padding-bottom: 12px;\n  background-color: #4caf50;\n  color: white;\n}\n\n.export-button {\n  background-color: #4caf50; /* Green background */\n  border: none; /* Remove borders */\n  color: white; /* White text */\n  padding: 15px 32px; /* Some padding */\n  text-align: center; /* Centered text */\n  text-decoration: none; /* Remove underline */\n  display: inline-block; /* Inline-block display */\n  font-size: 16px; /* Font size */\n  margin: 14px 12px; /* Margins for spacing */\n  cursor: pointer; /* Pointer cursor on hover */\n  border-radius: 4px; /* Rounded corners */\n  transition: background-color 0.3s, transform 0.2s; /* Smooth transitions */\n}\n\n.export-button:hover {\n  background-color: #45a049; /* Darker green on hover */\n  transform: scale(1.05); /* Slightly enlarge on hover */\n}\n\n.export-button:active {\n  background-color: #388e3c; /* Even darker green when clicked */\n  transform: scale(0.95); /* Slightly shrink on click */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
